import { getIsDesktop } from '@bridebook/web/app-basic/lib/app/selectors';
import { getActualCategory, getSearchFields } from '@bridebook/web/app-basic/lib/search/selectors';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import { useTranslation } from 'next-i18next';
import { CountryCodes } from '@bridebook/toolbox/src/gazetteer';
import { Button, ImageX } from '@bridebook/ui';
import SignupLink from '@bridebook/web/app-shared/components/signup-link/signup-link';
import { useMarket } from '@bridebook/web/app-shared/lib/i18n/hooks/use-market';
import { prettySupplierCategory } from '@bridebook/web/app-shared/lib/utils';
import { getLocationInfoPhrasing } from '@bridebook/web/lib/search/utils';
import formatArea from '@bridebook/web/lib/search/utils/format-prediction-area';
import { IMAGES_BASE_URL } from '@bridebook/toolbox/src/buildImageUrl';

interface IProps {
  facets: string[];
  totalResults: number;
}

const getImageName = (country: string) => {
  switch (country) {
    case CountryCodes.DE:
      return 'search-signup-cta-de.png';
    case CountryCodes.FR:
      return 'search-signup-cta-fr.png';
    case CountryCodes.GB:
    case CountryCodes.IE:
    default:
      return 'search-signup-cta-uk.png';
  }
};

const SignUpNowCard = ({ totalResults, facets }: IProps) => {
  const market = useMarket();
  const { t } = useTranslation('search');
  const isDesktop = useSelector(getIsDesktop);

  const actualCategory = useSelector(getActualCategory);
  const { area } = useSelector(getSearchFields);

  if (facets?.length) return null;

  const prettyCategory = prettySupplierCategory({
    isLoggedIn: false,
    slug: actualCategory,
    amount: totalResults,
    addWedding: false,
    capitalize: false,
    market,
  });
  const formattedNum = market.formatNumber(totalResults);
  const nearPhrasing = getLocationInfoPhrasing(area, false);
  const formattedArea = formatArea(area);
  const imageName = getImageName(market.country);
  const imageSize = isDesktop ? 400 : 280;

  return (
    <div className="bscta">
      <ImageX
        src={`${IMAGES_BASE_URL}/assets/search/${imageName}`}
        w={imageSize}
        h={imageSize}
        style={{ paddingBottom: 0 }}
        imageStyle={{ position: 'relative' }}
      />
      <div className="bscta-info">
        <div className="bscta-title">
          {t('signUpNowResults', {
            formattedNum,
            prettyCategory,
            nearPhrasing,
            area: formattedArea,
          })}
        </div>
        <div className="bscta-text">{t('signUpNowDescription')}</div>
        <div className="bscta-cta">
          <SignupLink>
            <Button theme="primary" size="big" text={t('signUpNow.button')} width="block" />
          </SignupLink>
        </div>
      </div>
    </div>
  );
};

export default SignUpNowCard;
